import React from 'react';
import { SchemaProps } from '@stack/components';

export const getSignUpFields = ({
  password,
  setPassword,
  handleOTPRequest,
}: {
  password: string;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
  handleOTPRequest: any;
}): SchemaProps => {
  return [
    {
      name: 'first_name',
      key: 'TextField',
      colSpan: 6,
      props: {
        fullWidth: true,
        label: 'First Name',
        placeholder: 'First Name',
      },
    },
    {
      name: 'last_name',
      key: 'TextField',
      colSpan: 6,
      props: {
        fullWidth: true,
        label: 'Last Name',
        placeholder: 'Last Name',
      },
    },
    {
      name: 'user_mobile',
      key: 'PhoneInput',
      props: {
        showRequired: false,
        onClickAction: handleOTPRequest,
        outlinedInputProps: {
          fullWidth: true,
          label: 'Phone Number',
          placeholder: 'Phone Number',
          required: true,
        },
        countryCodeProps: {
          className: 'font-medium mr-2 text-[1rem]',
          color: 'secondary',
        },
      },
    },
    {
      name: 'otp_no',
      key: 'TextField',
      props: {
        fullWidth: true,
        label: 'Enter 6-Digits OTP',
        placeholder: 'Enter 6-Digits OTP',
      },
    },
    {
      name: 'email',
      key: 'TextField',
      props: {
        fullWidth: true,
        label: 'Email',
        placeholder: '123@example.com',
      },
    },
    {
      name: 'password',
      key: 'PasswordInput',
      dataMap: ({ value }) => {
        setPassword(value);
      },
      props: {
        fullWidth: true,
        label: 'Password',
        placeholder: 'Enter Password',
      },
    },
    {
      name: 'confirm_password',
      key: 'PasswordInput',
      props: {
        fullWidth: true,
        label: 'Confirm Password',
        placeholder: 'Confirm Password',
      },
    },
    {
      key: 'PasswordVerify',
      type: 'component',
      name: 'password-verify',
      props: {
        password,
        containerProps: {
          pt: 2,
          gap: 2,
        },
        titleProps: {
          color: 'secondary',
        },
        rulesTitleProps: {
          color: 'secondary',
        },
      },
    },
  ];
};
